import React from 'react';

import { Text } from '../../../core-ui';
import formatCurrency from '../../../core/support/formatCurrency';
import { Row } from './helpers';

type Props = {
  currency: string;
  onCellClick: (row: Row) => void;
  row: Row;
};

export function FlatFeesCell(props: Props) {
  const { currency, onCellClick, row } = props;

  return (
    <Text paddingInline="8px" onClick={() => onCellClick(row)}>
      {formatCurrency(row.flatFeeTotal ?? 0, currency ?? undefined)}
    </Text>
  );
}
